module.exports = __webpack_public_path__ + "static/img/login_part01_img01.345e74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_part01_img01.png
// module id = bP6O
// module chunks = 1